import React from 'react';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';

const CustomPagination = styled(Pagination)(
  ({
    borderColor,
    textColor,
    selectedBgColor,
    selectedTextColor,
    selectedBorderColor,
    hoverBgColor,
    ellipsisBorder,
    borderWidth,
    borderStyle,
  }) => ({
    '& .MuiPaginationItem-root': {
      border: `${borderWidth || '1px'} ${borderStyle || 'solid'} ${
        borderColor || '#C56616'
      }`,
      color: textColor || '#C56616',
    },
    '& .MuiPaginationItem-root:hover': {
      backgroundColor: hoverBgColor || 'transparent',
    },
    '& .Mui-selected': {
      backgroundColor: selectedBgColor || '#1976d2 !important',
      color: selectedTextColor || '#fff !important',
      borderColor: selectedBorderColor || '#1976d2',
    },
    '& .MuiPaginationItem-ellipsis': {
      border: ellipsisBorder || 'none',
    },
  })
);

const ReusablePagination = ({
  count,
  page,
  onChange,
  showFirstButton,
  showLastButton,
  variant = 'outlined',
  shape = 'rounded',
  borderColor,
  textColor,
  selectedBgColor,
  selectedTextColor,
  selectedBorderColor,
  hoverBgColor,
  ellipsisBorder,
  borderWidth,
  borderStyle,
  ...props
}) => {
  return (
    <Stack spacing={2} alignItems="center">
      <CustomPagination
        count={count}
        page={page}
        onChange={onChange}
        variant={variant}
        shape={shape}
        showFirstButton={showFirstButton}
        showLastButton={showLastButton}
        borderColor={borderColor}
        textColor={textColor}
        selectedBgColor={selectedBgColor}
        selectedTextColor={selectedTextColor}
        selectedBorderColor={selectedBorderColor}
        hoverBgColor={hoverBgColor}
        ellipsisBorder={ellipsisBorder}
        borderWidth={borderWidth}
        borderStyle={borderStyle}
        {...props}
      />
    </Stack>
  );
};

export default ReusablePagination;
